import React, { useState } from "react";
import "./datatable.scss";
import { Input, Tag, Typography, Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import moment from "moment";
import { Link } from "react-router-dom";
import BookingInformationModal from "../../../pages/helpline_history/BookingInformationModal";
import { SingleCounsellingData } from "../../../types/WellnessCounsellingTypes";
import { useB2BContext } from "../../../context/ContextB2B";
import { AppTable } from "../../common";


const { Text } = Typography;

function HelplineDataTable({
  contentData,
  sessionLoading,
  tableTitle = "Wellness Counseling Bookings",
}: {
  contentData: any;
  sessionLoading: boolean;
  tableTitle?: string;
}) {
  const [searchText, setSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] =
    useState<SingleCounsellingData | null>(null);
  const { getUserByID } = useB2BContext();

  const columns: ColumnsType<SingleCounsellingData> = [
   {
    title: "Booking ID",
    dataIndex: "_id",
    key: "_id",
    filteredValue: searchText ? [searchText] : null,
   onFilter: (value, record) => {
  const search = (value as string).toLowerCase();

  return (
    record._id?.toLowerCase().includes(search) ||
    record.sessionStatus?.toLowerCase().includes(search) ||
    record.timeSlot?.toLowerCase().includes(search) ||
    record.previousCounselors?.[0]?.toLowerCase().includes(search) ||
    record.date?.toLowerCase().includes(search) ||
   
  new Date(record.date)
    .toLocaleDateString("en-GB") 
    .toLowerCase()
    .includes(search)
  );
},

    ellipsis: true,
    className: "sessionId",
     width: 120,
  },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (item) => item ? moment(item).format("DD/MM/YY") : "-",
      width: 100,
    },
    {
      title: "Time Slot",
      dataIndex: "timeSlot",
      key: "timeSlot",
      width: 160,
    },
    {
      title: "Payment",
      dataIndex: "isPaid",
      key: "isPaid",
      width: 90,
      render: (item) =>
        item === true ? (
          <Tag color="green">Paid</Tag>
        ) : (
          <Tag color="red">Not Paid</Tag>
        ),
    },
    {
      title: "Session Status",
      dataIndex: "sessionStatus",
      key: "sessionStatus",
      width: 120,
    },
    {
      title: "Previous Counselor",
      dataIndex: "previousCounselors",
      key: "previousCounselors",
      width: 140,
      render: (item) =>
        Array.isArray(item) && item.length > 0 ? item[0] : "-"
    },
    {
      title: "Q/A",
      dataIndex: "icpAnswersPdf",
      key: "icpAnswersPdf",
      width: 130,
      render: (item) =>
        item === "" || item === null ? (
          <Tag color="red">Not Found</Tag>
        ) : (
          <Link
            to={item}
            className="table_pill_btn table_pill_btn--view"
            target="_blank"
            rel="noreferrer"
          >
            View PDF
          </Link>
        ),
    },
    {
      title: "Client ID",
      dataIndex: "user",
      key: "user",
       width: 140,
      ellipsis: true,
       render: (item) =>
        item?._id ?? "-"
    },
   {
  title: "Action",
  key: "action",
  width: 130,
  className: "actionCls",
  render: (_, record) => {
    const previous = (record as any).previousCounselors;

    return (
      <Button
        className="table_pill_btn table_pill_btn--view"
        onClick={() => {
          setIsModalOpen(true);
          setSelectedBooking(record);
        }}
        disabled={ getUserByID?.user_type === "Company_member"
    ? getUserByID?.roles?.includes("Counselor")
    : getUserByID?.user_type === "Counselor" }
      >
        {Array.isArray(previous) && previous.length > 0 ? "Reassign" : "Assign"}
      </Button>
    );
  },
},

  ];
  return (
    <div className="dataTable">
      <div className="filterMenu">
        <Text className="title24">{tableTitle}</Text>
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        loading={sessionLoading}
        rowKey={(record) => record._id}
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
      <BookingInformationModal
        booking={selectedBooking}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
}

export default HelplineDataTable;
